import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import useRootHook from "../../hooks/useRoot";
import methods from "../../models/payout-methods";
import helpers from "../../helpers/common";
import PayoutMethodForm from "./PayoutMethodForm";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function PayoutMethodAdd(props) {
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [errors, setErrors] = useState({})
    const [fields, setFields] = useState({})
    // no prefetch needed here

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof methods.fieldValidator[name] === 'function'
        && methods.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = methods.methodValidator.add(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        methods.add(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/payout-methods')
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Add payout method" breadcrumbs={[['Dashboard', '/'], ['Payout Methods', '/payout-methods'], ['Add', '/payout-methods/add']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <PayoutMethodForm fields={fields} errors={errors} handleChange={handleChange}
                                  handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}